export const workEnvironment = {
  junior: {
    macos: [
      { step: 'Install Homebrew', command: '/bin/bash -c "$(curl -fsSL https://raw.githubusercontent.com/Homebrew/install/HEAD/install.sh)"' },
      { step: 'Install Docker Desktop', command: 'brew install --cask docker' },
      { step: 'Install AWS CLI', command: 'brew install awscli' },
      { step: 'Install Terraform', command: 'brew install terraform' },
      { step: 'Install kubectl', command: 'brew install kubectl' },
      { step: 'Install Git', command: 'brew install git' },
      { step: 'Install VS Code', command: 'brew install --cask visual-studio-code' }
    ],
    windows: [
      { step: 'Install Chocolatey', command: 'Set-ExecutionPolicy Bypass -Scope Process -Force; [System.Net.ServicePointManager]::SecurityProtocol = [System.Net.ServicePointManager]::SecurityProtocol -bor 3072; iex ((New-Object System.Net.WebClient).DownloadString(\'https://community.chocolatey.org/install.ps1\'))' },
      { step: 'Install Docker Desktop', command: 'choco install docker-desktop' },
      { step: 'Install Azure CLI', command: 'choco install azure-cli' },
      { step: 'Install Terraform', command: 'choco install terraform' },
      { step: 'Install kubectl', command: 'choco install kubernetes-cli' },
      { step: 'Install Git', command: 'choco install git' },
      { step: 'Install VS Code', command: 'choco install vscode' }
    ],
    linux: [
      { step: 'Update package manager', command: 'sudo apt update && sudo apt upgrade -y' },
      { step: 'Install Docker', command: 'curl -fsSL https://get.docker.com -o get-docker.sh && sh get-docker.sh' },
      { step: 'Install AWS CLI', command: 'curl "https://awscli.amazonaws.com/awscli-exe-linux-x86_64.zip" -o "awscliv2.zip" && unzip awscliv2.zip && sudo ./aws/install' },
      { step: 'Install Terraform', command: 'wget -O- https://apt.releases.hashicorp.com/gpg | gpg --dearmor | sudo tee /usr/share/keyrings/hashicorp-archive-keyring.gpg && echo "deb [signed-by=/usr/share/keyrings/hashicorp-archive-keyring.gpg] https://apt.releases.hashicorp.com $(lsb_release -cs) main" | sudo tee /etc/apt/sources.list.d/hashicorp.list && sudo apt update && sudo apt install terraform' },
      { step: 'Install kubectl', command: 'curl -LO "https://dl.k8s.io/release/$(curl -L -s https://dl.k8s.io/release/stable.txt)/bin/linux/amd64/kubectl" && sudo install -o root -g root -m 0755 kubectl /usr/local/bin/kubectl' }
    ]
  },
  mid: {
    macos: [
      { step: 'Install Helm', command: 'brew install helm' },
      { step: 'Install Ansible', command: 'brew install ansible' },
      { step: 'Install Jenkins CLI', command: 'brew install jenkins' },
      { step: 'Install Prometheus', command: 'brew install prometheus' },
      { step: 'Install Grafana', command: 'brew install grafana' },
      { step: 'Install Vault', command: 'brew install vault' }
    ],
    windows: [
      { step: 'Install Helm', command: 'choco install kubernetes-helm' },
      { step: 'Install Ansible', command: 'pip install ansible' },
      { step: 'Install PowerShell Core', command: 'choco install powershell-core' },
      { step: 'Install Azure DevOps CLI', command: 'az extension add --name azure-devops' },
      { step: 'Install Packer', command: 'choco install packer' }
    ],
    linux: [
      { step: 'Install Helm', command: 'curl https://baltocdn.com/helm/signing.asc | sudo apt-key add - && sudo apt-get install apt-transport-https --yes && echo "deb https://baltocdn.com/helm/stable/debian/ all main" | sudo tee /etc/apt/sources.list.d/helm-stable-debian.list && sudo apt-get update && sudo apt-get install helm' },
      { step: 'Install Ansible', command: 'sudo apt install ansible' },
      { step: 'Install Jenkins', command: 'wget -q -O - https://pkg.jenkins.io/debian-stable/jenkins.io.key | sudo apt-key add - && sudo sh -c \'echo deb https://pkg.jenkins.io/debian-stable binary/ > /etc/apt/sources.list.d/jenkins.list\' && sudo apt-get update && sudo apt-get install jenkins' },
      { step: 'Install Prometheus', command: 'wget https://github.com/prometheus/prometheus/releases/download/v2.40.0/prometheus-2.40.0.linux-amd64.tar.gz && tar xvfz prometheus-*.tar.gz && sudo mv prometheus-*/prometheus /usr/local/bin/' }
    ]
  },
  senior: {
    macos: [
      { step: 'Install Istio CLI', command: 'brew install istioctl' },
      { step: 'Install Consul', command: 'brew install consul' },
      { step: 'Install Nomad', command: 'brew install nomad' },
      { step: 'Install Jaeger', command: 'brew install jaeger' },
      { step: 'Install OpenTelemetry Collector', command: 'brew install opentelemetry-collector' }
    ],
    windows: [
      { step: 'Install Consul', command: 'choco install consul' },
      { step: 'Install Vault', command: 'choco install vault' },
      { step: 'Install Nomad', command: 'choco install nomad' },
      { step: 'Install Packer', command: 'choco install packer' }
    ],
    linux: [
      { step: 'Install Istio', command: 'curl -L https://istio.io/downloadIstio | sh - && sudo mv istio-*/bin/istioctl /usr/local/bin/' },
      { step: 'Install Consul', command: 'wget https://releases.hashicorp.com/consul/1.16.0/consul_1.16.0_linux_amd64.zip && unzip consul_1.16.0_linux_amd64.zip && sudo mv consul /usr/local/bin/' },
      { step: 'Install Vault', command: 'wget https://releases.hashicorp.com/vault/1.14.0/vault_1.14.0_linux_amd64.zip && unzip vault_1.14.0_linux_amd64.zip && sudo mv vault /usr/local/bin/' },
      { step: 'Install Jaeger', command: 'docker run -d --name jaeger -p 16686:16686 -p 14268:14268 jaegertracing/all-in-one:latest' }
    ]
  }
};
